import * as React from 'react';
import { CONFIG } from './config';
import * as Cookie from 'js-cookie';

export interface IGlobalStoreState {
  email: string;
  password: string;
}

interface IGlobalContext {
  store: IGlobalStoreState;
  actions: {
    setEmail: (email: string) => void;
    setPassword: (password: string) => void;
  };
}

export const GlobalContext = React.createContext<IGlobalContext>({
  store: {
    email: '',
    password: '',
  },
  actions: {
    setEmail: () => {},
    setPassword: () => {},
  },
});

interface IProps {}

export const GlobalProvider: React.FC<IProps> = props => {
  const email = React.useState('');
  const password = React.useState('');

  // React.useEffect(() => {
  //   if (props.language[0] === 'ar') {
  //     document.body.classList.add('rtl');
  //   } else {
  //     document.body.classList.remove('rtl');
  //   }

  //   Cookie.set('language', props.language[0], CONFIG.COOKIE_CONFIG);
  // }, [props.language[0]]);

  return (
    <GlobalContext.Provider
      value={{
        store: {
          email: email[0],
          password: password[0],
        },
        actions: {
          setEmail: email[1],
          setPassword: password[1],
        },
      }}>
      {props.children}
    </GlobalContext.Provider>
  );
};
